var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "", "pb-4": "" } },
    [
      _c("v-flex", { staticClass: "form-section", attrs: { xs12: "" } }, [
        _c(
          "div",
          { staticClass: "mx-3" },
          [
            _c(
              "v-flex",
              { attrs: { "mb-3": "" } },
              [
                _c("v-layout", { staticClass: "title--text-custom" }, [
                  _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "primary--text" }, [
                  _vm._v("Informations générales")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-control-label-vertical",
              {
                attrs: {
                  required: "",
                  label: _vm.lblSetting.ticketSubstatusName
                }
              },
              [
                _c("v-text-field", {
                  attrs: {
                    counter: _vm.textConfigs.input,
                    maxlength: _vm.textConfigs.input,
                    required: "",
                    rules: _vm.dtRules.nameRules,
                    solo: ""
                  },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-835541e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-835541e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/ticket-substatus-modal-vertical/template.html
// module id = null
// module chunks = 